import axios from 'axios'

const state = {
  accounts: null,
  aliases: null,
  forwards: null,
}

const getters = {
  StateMailAccounts: state => state.accounts,
  StateMailAliases: state => state.aliases,
  StateMailForwards: state => state.forwards,
}

const actions = {
  async CreateMailAccount ({ dispatch }, account) {
    return axios
      .post('mail/accounts', account)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetMailAccounts', account.domain_id)
      })
  },
  async GetMailAccounts ({ commit }, domain_id) {
    const response = await axios.get('mail/accounts', {params: {domain_id: domain_id }})
    commit('setAccounts', response.data)
    //console.log(response.data)
  },
  async UpdateMailAccount ({ dispatch }, account) {
    return axios
      .put('mail/accounts/' + account.id, account)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetMailAccounts', account.domain_id)
      })
  },
  async DeleteMailAccount ({ dispatch }, account) {
    return axios
      .delete('mail/accounts/' + account.id)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetMailAccounts', account.domain_id)
      })
  },

  //
  // Aliases
  //

  async CreateMailAlias ({ dispatch }, alias) {
    return axios
      .post('mail/aliases', alias)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetMailAliases', alias.domain_id)
      })
  },
  async GetMailAliases ({ commit }, domain_id) {
    const response = await axios.get('mail/aliases', {params: {domain_id: domain_id }})
    commit('setAliases', response.data)
    //console.log(response.data)
  },
  async UpdateMailAlias ({ dispatch }, alias) {
    return axios
      .put('mail/aliases/' + alias.id, alias)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetMailAliases', alias.domain_id)
      })
  },
  async DeleteMailAlias ({ dispatch }, alias) {
    return axios
      .delete('mail/aliases/' + alias.id)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetMailAliases', alias.domain_id)
      })
  },

  //
  // Forwards
  //

  async CreateMailForward ({ dispatch }, forward) {
    return axios
      .post('mail/forwards', forward)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetMailForwards', forward.domain_id)
      })
  },
  async GetMailForwards ({ commit }, domain_id) {
    const response = await axios.get('mail/forwards', {params: {domain_id: domain_id }})
    commit('setForwards', response.data)
    //console.log(response.data)
  },
  async UpdateMailForward ({ dispatch }, forward) {
    return axios
      .put('mail/forwards/' + forward.id, forward)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetMailForwards', forward.domain_id)
      })
  },
  async DeleteMailForward ({ dispatch }, forward) {
    return axios
      .delete('mail/forwards/' + forward.id)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetMailForwards', forward.domain_id)
      })
  }

}

const mutations = {
  setAccounts (state, accounts) {
    state.accounts = accounts
  },
  setAliases (state, aliases) {
    state.aliases = aliases
  },
  setForwards (state, forwards) {
    state.forwards = forwards
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}